export default __webpack_public_path__ + "components/weather-icon/static/nightsomecloud-2e9ffef909d4bff3fb1806432677e637.svg";